import React, { useState, ChangeEvent, FormEvent, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ProfileDetails, UpdateProfile } from "../../store/ProfileSlice";
import { RootState } from "../../store/store";
import { PatientsState } from "../../interfaces/Patients";
import { startUpload } from "../../store/imageSlice";
import { toast } from "react-toastify";

const ProfileUpdate = () => {
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [fullname, setFullname] = useState("");
  const [phone, setPhone] = useState("");
  const [bio, setBio] = useState("");
  const [images, setImages] = useState<string | null>(null);
  const [image, setImage] = useState<File | null>(null);

  const [selectedImage, setSelectedImage] = useState<File | null>(null);
  const [errors, setError] = useState<string | null>(null);

  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleImageChange = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setSelectedImage(file);
    }
    // Validate file type
    if (file && file.type.includes("image")) {
      // Set the selected image for preview
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImage(file);
      };
      reader.readAsDataURL(file);

      // Set the selected image file
      setImage(file);
      setError(null);
    } else {
      // Handle invalid file type
      setSelectedImage(null);
      setImage(null);
      setError("Please upload a valid image file.");
    }
  };
  const handleFullNameChange = (e: ChangeEvent<HTMLInputElement>) => {
    setFullname(e.target.value);
  };

  const handlephoneChange = (e: ChangeEvent<HTMLInputElement>) => {
    setPhone(e.target.value);
  };

  const handlebioChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    setBio(e.target.value);
  };

  const userData = useSelector((state: RootState) => {
    const profileData = state.profile.data;

    if (!profileData || Array.isArray(profileData)) {
      // Handle the case where data is null or an array
      return {} as PatientsState; // You might want to return an appropriate default object
    }
    localStorage.setItem('profile', JSON.stringify(profileData));
    return profileData as PatientsState;
  });


  useEffect(() => {
    const fetchData = async () => {
      try {
        await dispatch(ProfileDetails());
        setEmail(userData.email || ""); // Assuming the name field holds the title
        setImages(userData.icon || "");
        setFullname(userData.fullName || "");
        setPhone(userData.phoneNo || "");
        setBio(userData.bio || "");
      } catch (error) {
        console.error("Error fetching user profile details:", error);
      }
    };


    fetchData();

  }, [dispatch]);



  const loading = useSelector((state: RootState) => state.profile.loading);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    dispatch(startUpload());
    const formData = new FormData();
     (fullname)? formData.append('fullName', fullname) : "";
     (phone)? formData.append('phoneNo', phone) : "";
     (bio)? formData.append('bio', bio) : "";
    if (selectedImage) {
      formData.append("icon", selectedImage);
    }

      try {
        await dispatch(UpdateProfile(formData)).then(() => {
          toast.success("Profile Updated Successfully");
          dispatch(ProfileDetails());
        });
        // Optionally, you can add logic for successful update, e.g., show a success message
      } catch (err) {
        // Handle error, e.g., display an error message
        console.error("Error updating profile:", err);
      }
  };

  if (loading) {
    return <p>Loading...</p>;
  }

  return (
      <>

    <div className="px-8 overflow-y-scroll max-h-[calc(100vh-220px)] scrollbar-hide pb-20">
      <form onSubmit={handleSubmit}>
        <div className=" mt-4 mb-8 ">
        <div className="flex items-center  w-full relative">
            <label
              className={`flex`}
            >
              <div className="flex flex-col items-center justify-center pt-5 pb-6 absolute -left-16 w-96 top-2">
              <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="16.5" cy="16.5" r="15.5" fill="#037897" stroke="white" stroke-width="2"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M20.8867 12.3216V12.3216C20.6044 12.3216 20.3487 12.1589 20.2283 11.9046C20.0111 11.4445 19.7349 10.8565 19.5715 10.5364C19.3301 10.0604 18.9388 9.7834 18.397 9.77962C18.3879 9.77886 14.8523 9.77886 14.8433 9.77962C14.3014 9.7834 13.9109 10.0604 13.6688 10.5364C13.5061 10.8565 13.2298 11.4445 13.0127 11.9046C12.8923 12.1589 12.6358 12.3216 12.3543 12.3216V12.3216C10.8438 12.3216 9.62012 13.5452 9.62012 15.055V19.5471C9.62012 21.0561 10.8438 22.2805 12.3543 22.2805H20.8867C22.3964 22.2805 23.6201 21.0561 23.6201 19.5471V15.055C23.6201 13.5452 22.3964 12.3216 20.8867 12.3216Z" stroke="white" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M14.2149 17.032C14.2142 18.3586 15.2971 19.4438 16.6214 19.4431C17.9435 19.4415 19.0234 18.3609 19.0256 17.0373C19.0279 15.7085 17.9488 14.6255 16.6229 14.624C15.2895 14.6225 14.2043 15.7236 14.2149 17.032Z" stroke="white" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M20.3314 15.2617C20.2583 15.2542 20.1861 15.2352 20.1052 15.2026C20.0152 15.1626 19.9374 15.1118 19.8621 15.0353C19.7268 14.8914 19.6484 14.7032 19.6484 14.5091C19.6484 14.406 19.6695 14.3037 19.7107 14.2112C19.7519 14.1174 19.8008 14.0382 19.8892 13.9522C19.9564 13.8936 20.0253 13.8465 20.1194 13.805C20.3986 13.6944 20.7307 13.7605 20.9382 13.9679C21.0004 14.0292 21.0528 14.1032 21.0818 14.1655L21.0991 14.2097C21.1409 14.3037 21.162 14.406 21.162 14.5091C21.162 14.7071 21.0846 14.8903 20.9411 15.0428C20.817 15.1677 20.6541 15.2445 20.4803 15.2618L20.4052 15.2655L20.3314 15.2617Z" fill="white"/>
                </svg>

              </div>
              <input
                id="image"
                type="file"
                name="image"
                onChange={handleImageChange}
                className={"visually-hidden"} // Corrected syntax
                accept="image/*"
                // required = {!userData?.icon}
                ref={fileInputRef}
              />
            </label>
            {selectedImage instanceof File && (
              <img
                src={URL.createObjectURL(selectedImage)}
                alt="preview"
                className="w-auto max-w-md pl-2 h-32 object-contain rounded-full"
              />
            )}
            {userData?.icon ? (
                <img
                    src={userData?.icon}
                    alt="preview"
                    className={`w-auto max-w-md pl-2 h-32 object-contain rounded-full ${
                        selectedImage && "hidden"
                    } `}
                />
            ) : (
              <img src='./images/user/default-avatar.jpg' alt="User"  className={`w-auto max-w-md pl-2 h-32 object-contain rounded-full ${
                selectedImage && "hidden"
            } `} />

          )}


            {errors && <p style={{ color: "red" }}>{errors}</p>}
          </div>

        </div>
        <div className="flex flex-col md:flex-row">
          <div className="mb-5  w-full  pr-4">
            <label
              className="block text-[#4C535F] text-lg  mb-2"
              htmlFor="fullname"
            >
              Full Name
            </label>
            <input
              type="text"
              id="fullname"
              name="fullname"
              // defaultValue={userData?.fullName}
              defaultValue={userData?.fullName}
              onChange={handleFullNameChange}
              readOnly={false}
              className="border text-[#263238] bg-[#EDF2F6] font-[18px] w-full focus:outline-teal focus:bg-white font-gilroy-medium border-[#E0E4EC] rounded-[8px] p-3 "
              placeholder="Please enter your first name"
              required
            />
          </div>
          </div>

        <div className="flex flex-col md:flex-row">
        <div className="mb-5 w-full md:w-1/2 pr-4">
            <label
              className="block text-[#4C535F] text-lg  mb-2"
              htmlFor="Email"
            >
              Email Address
            </label>
            <input
              type="text"
              id="email"
              name="email"
              // defaultValue={userData?.email}
              defaultValue={userData?.email}
              readOnly={false}
              className="border text-[#263238] bg-[#EDF2F6] font-[18px] w-full focus:outline-teal focus:bg-white font-gilroy-medium border-[#E0E4EC] rounded-[8px] p-3 "
              placeholder="Please enter your Email"
              disabled
            />
          </div>

          <div className="mb-5 w-full md:w-1/2  pr-4">
            <label
              className="block text-[#4C535F] text-lg mb-2"
              htmlFor="phone"
            >
              Phone number
            </label>
            <input
              type="text"
              id="phone"
              name="phone"
              pattern="[0-9]*"
              // defaultValue={userData?.phoneNo}
              defaultValue={userData?.phoneNo}
              onChange={handlephoneChange}
              readOnly={false}
              className="border text-[#263238] bg-[#EDF2F6] font-[18px] w-full focus:outline-teal focus:bg-white font-gilroy-medium border-[#E0E4EC] rounded-[8px] p-3 "
              placeholder="Please enter your phone number"
              maxLength={10}
              title="Please enter a valid 10-digit phone number"
              required
            />
          </div>

                    </div>
          <div className="flex flex-col md:flex-row">
          <div className="mb-5 w-full  pr-4">
            <label
              className="block text-[#4C535F] text-lg mb-2"
              htmlFor="bio"
            >
              Bio
            </label>
            <textarea
              id="bio"
              name="bio"
              // defaultValue={userData?.bio}
              defaultValue={userData?.bio}
              onChange={handlebioChange}
              readOnly={false}
              className="resize-none border text-[#263238] bg-[#EDF2F6] font-[18px] w-full focus:outline-teal focus:bg-white font-gilroy-medium border-[#E0E4EC] rounded-[8px] p-3 "
              rows={4}
              placeholder="Please enter your bio"
            ></textarea>
          </div>
        </div>

        <button
          type="submit"
          className="bg-[#037897] text-white font-semibold float-right w-40 py-2 px-4 mb-8 rounded-md"
        >
          Save Changes
        </button>

      </form>
    </div>


    </>
  );
};

export default ProfileUpdate;